/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AddFreeTicketResponseApiFrom } from '../models/add-free-ticket-response-api-from';
import { AddVoucherResponseApiFrom } from '../models/add-voucher-response-api-from';
import { apiV3ServiceAddCouponPaymentPost } from '../fn/coupon/api-v-3-service-add-coupon-payment-post';
import { ApiV3ServiceAddCouponPaymentPost$Params } from '../fn/coupon/api-v-3-service-add-coupon-payment-post';
import { apiV3ServiceAddFreeTicketPost } from '../fn/coupon/api-v-3-service-add-free-ticket-post';
import { ApiV3ServiceAddFreeTicketPost$Params } from '../fn/coupon/api-v-3-service-add-free-ticket-post';
import { apiV3ServiceAddFreeTicketPost$Plain } from '../fn/coupon/api-v-3-service-add-free-ticket-post-plain';
import { ApiV3ServiceAddFreeTicketPost$Plain$Params } from '../fn/coupon/api-v-3-service-add-free-ticket-post-plain';
import { apiV3ServiceAddVoucherGet } from '../fn/coupon/api-v-3-service-add-voucher-get';
import { ApiV3ServiceAddVoucherGet$Params } from '../fn/coupon/api-v-3-service-add-voucher-get';
import { apiV3ServiceAddVoucherGet$Plain } from '../fn/coupon/api-v-3-service-add-voucher-get-plain';
import { ApiV3ServiceAddVoucherGet$Plain$Params } from '../fn/coupon/api-v-3-service-add-voucher-get-plain';
import { apiV3ServiceGetCouponDiscountGet } from '../fn/coupon/api-v-3-service-get-coupon-discount-get';
import { ApiV3ServiceGetCouponDiscountGet$Params } from '../fn/coupon/api-v-3-service-get-coupon-discount-get';
import { apiV3ServiceGetCouponDiscountGet$Plain } from '../fn/coupon/api-v-3-service-get-coupon-discount-get-plain';
import { ApiV3ServiceGetCouponDiscountGet$Plain$Params } from '../fn/coupon/api-v-3-service-get-coupon-discount-get-plain';
import { apiV3ServiceSetCouponFreePost } from '../fn/coupon/api-v-3-service-set-coupon-free-post';
import { ApiV3ServiceSetCouponFreePost$Params } from '../fn/coupon/api-v-3-service-set-coupon-free-post';
import { CouponDiscountApiFrom } from '../models/coupon-discount-api-from';

@Injectable({ providedIn: 'root' })
export class ApiFromCouponService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiV3ServiceAddCouponPaymentPost()` */
  static readonly ApiV3ServiceAddCouponPaymentPostPath = '/api/v3/service/AddCouponPayment';

  /**
   * Top up with a coupon.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceAddCouponPaymentPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV3ServiceAddCouponPaymentPost$Response(params?: ApiV3ServiceAddCouponPaymentPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiV3ServiceAddCouponPaymentPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Top up with a coupon.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceAddCouponPaymentPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV3ServiceAddCouponPaymentPost(params?: ApiV3ServiceAddCouponPaymentPost$Params, context?: HttpContext): Observable<void> {
    return this.apiV3ServiceAddCouponPaymentPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiV3ServiceGetCouponDiscountGet()` */
  static readonly ApiV3ServiceGetCouponDiscountGetPath = '/api/v3/service/GetCouponDiscount';

  /**
   * Get the discount amount of the coupon. Also locks the coupon and extends the lock time when requested again.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceGetCouponDiscountGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceGetCouponDiscountGet$Plain$Response(params?: ApiV3ServiceGetCouponDiscountGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CouponDiscountApiFrom>> {
    return apiV3ServiceGetCouponDiscountGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the discount amount of the coupon. Also locks the coupon and extends the lock time when requested again.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceGetCouponDiscountGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceGetCouponDiscountGet$Plain(params?: ApiV3ServiceGetCouponDiscountGet$Plain$Params, context?: HttpContext): Observable<CouponDiscountApiFrom> {
    return this.apiV3ServiceGetCouponDiscountGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CouponDiscountApiFrom>): CouponDiscountApiFrom => r.body)
    );
  }

  /**
   * Get the discount amount of the coupon. Also locks the coupon and extends the lock time when requested again.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceGetCouponDiscountGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceGetCouponDiscountGet$Response(params?: ApiV3ServiceGetCouponDiscountGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CouponDiscountApiFrom>> {
    return apiV3ServiceGetCouponDiscountGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the discount amount of the coupon. Also locks the coupon and extends the lock time when requested again.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceGetCouponDiscountGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceGetCouponDiscountGet(params?: ApiV3ServiceGetCouponDiscountGet$Params, context?: HttpContext): Observable<CouponDiscountApiFrom> {
    return this.apiV3ServiceGetCouponDiscountGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CouponDiscountApiFrom>): CouponDiscountApiFrom => r.body)
    );
  }

  /** Path part for operation `apiV3ServiceSetCouponFreePost()` */
  static readonly ApiV3ServiceSetCouponFreePostPath = '/api/v3/service/SetCouponFree';

  /**
   * Removing the blocking from the coupon (before the blocking period expires).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceSetCouponFreePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV3ServiceSetCouponFreePost$Response(params?: ApiV3ServiceSetCouponFreePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiV3ServiceSetCouponFreePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Removing the blocking from the coupon (before the blocking period expires).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceSetCouponFreePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV3ServiceSetCouponFreePost(params?: ApiV3ServiceSetCouponFreePost$Params, context?: HttpContext): Observable<void> {
    return this.apiV3ServiceSetCouponFreePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiV3ServiceAddFreeTicketPost()` */
  static readonly ApiV3ServiceAddFreeTicketPostPath = '/api/v3/service/AddFreeTicket';

  /**
   * Obtaining a ticket with a voucher.
   *
   * Obtaining a ticket by redempting a "voucher" type coupon
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceAddFreeTicketPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV3ServiceAddFreeTicketPost$Plain$Response(params?: ApiV3ServiceAddFreeTicketPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AddFreeTicketResponseApiFrom>> {
    return apiV3ServiceAddFreeTicketPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtaining a ticket with a voucher.
   *
   * Obtaining a ticket by redempting a "voucher" type coupon
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceAddFreeTicketPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV3ServiceAddFreeTicketPost$Plain(params?: ApiV3ServiceAddFreeTicketPost$Plain$Params, context?: HttpContext): Observable<AddFreeTicketResponseApiFrom> {
    return this.apiV3ServiceAddFreeTicketPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AddFreeTicketResponseApiFrom>): AddFreeTicketResponseApiFrom => r.body)
    );
  }

  /**
   * Obtaining a ticket with a voucher.
   *
   * Obtaining a ticket by redempting a "voucher" type coupon
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceAddFreeTicketPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV3ServiceAddFreeTicketPost$Response(params?: ApiV3ServiceAddFreeTicketPost$Params, context?: HttpContext): Observable<StrictHttpResponse<AddFreeTicketResponseApiFrom>> {
    return apiV3ServiceAddFreeTicketPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtaining a ticket with a voucher.
   *
   * Obtaining a ticket by redempting a "voucher" type coupon
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceAddFreeTicketPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV3ServiceAddFreeTicketPost(params?: ApiV3ServiceAddFreeTicketPost$Params, context?: HttpContext): Observable<AddFreeTicketResponseApiFrom> {
    return this.apiV3ServiceAddFreeTicketPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<AddFreeTicketResponseApiFrom>): AddFreeTicketResponseApiFrom => r.body)
    );
  }

  /** Path part for operation `apiV3ServiceAddVoucherGet()` */
  static readonly ApiV3ServiceAddVoucherGetPath = '/api/v3/service/AddVoucher';

  /**
   * Obtaining a ticket or adding a value with a voucher.
   *
   * Obtaining a ticket or refilling a wallet by redempting a "voucher" type coupon
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceAddVoucherGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceAddVoucherGet$Plain$Response(params?: ApiV3ServiceAddVoucherGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AddVoucherResponseApiFrom>> {
    return apiV3ServiceAddVoucherGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtaining a ticket or adding a value with a voucher.
   *
   * Obtaining a ticket or refilling a wallet by redempting a "voucher" type coupon
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceAddVoucherGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceAddVoucherGet$Plain(params?: ApiV3ServiceAddVoucherGet$Plain$Params, context?: HttpContext): Observable<AddVoucherResponseApiFrom> {
    return this.apiV3ServiceAddVoucherGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AddVoucherResponseApiFrom>): AddVoucherResponseApiFrom => r.body)
    );
  }

  /**
   * Obtaining a ticket or adding a value with a voucher.
   *
   * Obtaining a ticket or refilling a wallet by redempting a "voucher" type coupon
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceAddVoucherGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceAddVoucherGet$Response(params?: ApiV3ServiceAddVoucherGet$Params, context?: HttpContext): Observable<StrictHttpResponse<AddVoucherResponseApiFrom>> {
    return apiV3ServiceAddVoucherGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtaining a ticket or adding a value with a voucher.
   *
   * Obtaining a ticket or refilling a wallet by redempting a "voucher" type coupon
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceAddVoucherGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceAddVoucherGet(params?: ApiV3ServiceAddVoucherGet$Params, context?: HttpContext): Observable<AddVoucherResponseApiFrom> {
    return this.apiV3ServiceAddVoucherGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<AddVoucherResponseApiFrom>): AddVoucherResponseApiFrom => r.body)
    );
  }

}
